import {DRY_SUCCESS} from "../../../reducers/robotsAndVehiclesReducer";


export const drySuccess = () =>{
    return {
        type: DRY_SUCCESS,
        payload: {}
    }
}